export function toDate(value) {
	let date = new Date(value);
	let isValid = date instanceof Date && !isNaN(date);

	if (!isValid) {
		return false;
	}

	return date;
}
